import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, computed, effect, inject, input } from '@angular/core';
import { FieldService } from '@core/jss-utils';
import { CoreJssProxyModule } from '@core/jss-proxy';
import type { TextField } from '@sitecore-jss/sitecore-jss-angular';

import { ContentSectionTheme } from './content-section.model';
import { ContentSectionService } from './content-section.service';

@Component({
  selector: 'wl-content-section',
  standalone: true,
  templateUrl: './content-section.component.html',
  styleUrls: [
    './content-section.component.ed.scss',
    './content-section.component.essent.scss',
  ],
  imports: [NgClass, NgTemplateOutlet, CoreJssProxyModule],
  providers: [ContentSectionService],
})
export class ContentSectionComponent {
  readonly id = input<string>();
  readonly fluid = input<boolean>(false);
  readonly hasContext = input<boolean>(false);
  readonly theme = input<ContentSectionTheme>(undefined);
  readonly title = input<TextField>();

  readonly #fieldService = inject(FieldService);
  readonly #contentSectionService = inject(ContentSectionService);

  readonly showTitle = computed(() =>
    this.#fieldService.showTextField(this.title())
  );

  constructor() {
    effect(() => this.#contentSectionService.theme.set(this.theme()), {
      allowSignalWrites: true,
    });
  }
}
